<template>
  <div>
    <div class="video-container" v-if="$mq !== 'mobile'">
      <video autoplay :muted="muted" loop id="VideoContent" data-autoplay>
        <source src="../assets/video/video.mp4" type="video/mp4">
      </video>
      <div class="controls">
        <div class="icon" :class="(muted)?'muted':'sounded'" @click="toggleSound"></div>
        <div class="text" @click="toggleSound">
          {{muted? 'Включить звук':'Выключить звук'}}
        </div>
      </div>

    </div>
    <div class="video-container" v-if="$mq === 'mobile'">


      <silentbox-single src="https://www.youtube.com/watch?v=3u3IaT0zBns" :autoplay="true" >
        <div class="play-button"></div>
      </silentbox-single>

    </div>
  </div>
</template>

<script>
    import VueSilentbox from 'vue-silentbox'
    export default {
        name: "VideoSection",
        data() {
            return {
                muted: true,
            }
        },
        components:{
            VueSilentbox
        }
        ,
        methods: {
            toggleSound() {
                this.muted = !this.muted;
            }
        }
    }
</script>

<style scoped lang="scss">
  .video-container {
    width: 100vw;
    height: 100vh;
    position: relative;
    /*z-index: 1;*/
    overflow: hidden;
  }

  #VideoContent {
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 100%;
    z-index: -1;
    position: relative;
  }

  .controls {
    z-index: 500;
    position: absolute;
    bottom: 10vh;
    left: 50%;
    transform: translateX(-50%);
    z-index: 600;
    .icon {
      height: 57px;
      width: 70px;
      background-position: top center;
      background-repeat: no-repeat;
      cursor: pointer;
      &.muted {
        background-image: url("../assets/icons/ico__sound_of.svg");
      }
      &.sounded {
        background-image: url("../assets/icons/ico__sound_on.svg");
      }
    }
    .text {
      cursor: pointer;
      text-decoration: underline;
      user-select: none;
    }
  }

  @media screen and (max-width: 768px) {
    .controls {
      bottom: 21vh;
    }
    .video-container {
      height: calc(100vh - 60px);
      position: relative;
      padding-bottom: 60px;
      background-image: url("../assets/images/blocks/intro_bg_mobile.jpg");
    }
    .play-button {
      position: absolute;
      left: 50%;
      top: 50%;
      background-image: url("../assets/images/play.png");
      width: 20vmin;
      height: 20vmin;
      background-size: cover;
      background-repeat: no-repeat;
      cursor: pointer;
      transform: translate(-50%, -50%);

    }
    .centered{
      position: absolute;
      left: 50%;
      top: 50%;
      max-width: 100vw;
      max-height: 80vh;
      transform: translate(-50%, -50%);
    }

  }

</style>